import React, { FC, Fragment, useMemo } from 'react';

import { useRoutesWithBreadcrumbs } from '../../context';
import { Tv } from './pages';

export const TvEntrypoint: FC = () => {
  const routesConfig = useMemo(() => [
    {
      label: 'Tv',
      element: <Tv />,
      path: '/',
      index: true,
    },
  ], []);

  const routes = useRoutesWithBreadcrumbs(routesConfig);

  return (
    <Fragment key="routes">{routes}</Fragment>
  );
};
